export default {
  FETCH_ERROR: 'FETCH_ERROR'
};



// WEBPACK FOOTER //
// ./src/stores/global/_types.js